import { useReveal } from "../../hooks/useReveal2";
import "./HowItWorks.css";

const STEPS = [
  {
    number: "1",
    color: "#38bdf8",
    title: "Get registered",
    text: "Sign up in a few minutes, choose your program's language and class.",
  },
  {
    number: "2",
    color: "#FDB022",
    title: "Explore your courses and start learning",
    text: "Access lessons, chat and take challenges with classmates",
  },
  {
    number: "3",
    color: "#10B981",
    title: "Progress every day",
    text: "Take quizzes, complete challenges and pass your assessments to track your progress.",
  },
];

export default function HowItWorks() {
  const scopeRef = useReveal();

  return (
    <section id="how-it-works" className="how-it-works" ref={scopeRef}>
      <div className="how-container">
        <div className="section-header reveal">
          <p className="eyebrow">🌞 Quick &amp; easy</p>
          <h2 className="section-title">How it works</h2>
          <p className="section-subtitle">Three steps to get started with MASOMO.</p>
        </div>

        <div className="steps">
          {STEPS.map((step, i) => (
            <div className={`step reveal reveal-delay-${i + 1}`} key={step.number}>
              <div className="step-number" style={{ background: step.color }}>
                {step.number}
              </div>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
              {i < STEPS.length - 1 && <span className="step-connector" aria-hidden="true" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
